import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":"","grid-list-md":""}},[_c('AppTitleBar',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.$t('title')))]},proxy:true}])}),(_vm.created)?_c('WizardSuccess',{attrs:{"on-reset":_vm.onWizardReset}}):_c(_vm.wizard,{tag:"component",attrs:{"on-submitted":_vm.onLeadCreated}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }